import { IEntityState } from '@signature-it/ngx-entity/store/interfaces';
import {createFeatureSelector, createSelector} from "@ngrx/store";
export const selectEntityStore = createFeatureSelector<IEntityState>('entity');
export const getPreviews = (state: IEntityState) => selectEntityStore(state).previews;
export const getIsLoadingPreviews = (state: IEntityState) => selectEntityStore(state).loadingPreviews;
export const getFavoritesList = (state: IEntityState)  => selectEntityStore(state).favoritesList;
export const getFavoritesVars = (state: IEntityState)  => selectEntityStore(state).favoritesVars;
export const loadingFavoritesList = (state: IEntityState)  => selectEntityStore(state).loadingFavoritesList;
export const updatedFavoritesSuccess = (state: IEntityState)  => selectEntityStore(state).updatedFavoritesSuccess;
export const removeFavoritesSuccess = (state: IEntityState)  => selectEntityStore(state).removeFavoritesSuccess;
